import {
	CHECKBOX_ATTR_CHECKED, CHECKBOX_ATTR_ENABLED,
	CHECKBOX_ATTR_ID,
	CHECKBOX_COMMANDS
} from './constants';

export const enableCheckBoxCommandsOnRestrictedMode = plugins => {
	if ( plugins.has( 'RestrictedEditingModeEditing' ) ) {
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( CHECKBOX_COMMANDS.GET_CONTENT );
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( CHECKBOX_COMMANDS.CHANGE );
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( CHECKBOX_COMMANDS.DIFF );
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( CHECKBOX_COMMANDS.DIFF_BULK );
		plugins.get( 'RestrictedEditingModeEditing' ).enableCommand( CHECKBOX_COMMANDS.ENABLED );
	}
};

export const getAttributesFromCheckBoxViewElement = viewElement => {
	let id = null;
	let checked = false;
	let newValue = false;
	let canReview = false;
	let enabled = true;
	if ( viewElement ) {
		id = viewElement.getAttribute( CHECKBOX_ATTR_ID );
		checked = viewElement.getAttribute( CHECKBOX_ATTR_CHECKED );
		newValue = viewElement.getAttribute( 'data-new-value' );
		canReview = viewElement.getAttribute( 'data-can-review' );
		enabled = viewElement.getAttribute( CHECKBOX_ATTR_ENABLED );
	}
	return { id, checked, newValue, canReview, enabled };
};

export function findDescendant( modelElement, predicate ) {
	const elements = [];
	if ( predicate( modelElement ) ) {
		return [ modelElement ];
	}
	if ( modelElement.getChildren ) {
		for ( const child of modelElement.getChildren() ) {
			const found = findDescendant( child, predicate );
			if ( found.length > 0 ) {
				elements.push( ...found );
			}
		}
	}
	return elements;
}

